import { Box, Button, TextField, Typography } from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import useFormNotificationController from './controller/form';
import ConfirmDialog from '../../components/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import DateHourPicker from '../../components/DateHourPicker';

interface Props {
  onClose: VoidFunction;
  onFetchData: Function
}

const NotificationForm = ({ onClose, onFetchData }: Props) => {
  const controller = useFormNotificationController({ onClose, onFetchData })
  const { t } = useTranslation("global");

  return (
    <Box>
      <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
        {t("notification_page.Create Notification")}
      </Typography>
      <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
        <Box
          sx={{
            p: 3,
            width: '50%',
            mt: 2,
            borderRadius: '15px',
            boxShadow:
              '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
          }}
        >
          <Box sx={{ width: '100%' }}>
            <Typography>{t("notification_page.Notification Detail")}</Typography>
            <TextField
              required
              fullWidth
              inputRef={controller.title}
              placeholder={`${t("notification_page.Enter Notification Header")}`}
              margin='normal'
            />
          </Box>
          <Box sx={{ width: '100%' }}>
            <Typography>{t("notification_page.Description")}</Typography>
            <TextField
              fullWidth
              inputRef={controller.description}
              multiline
              required
              rows={4}
              placeholder={`${t("notification_page.Enter Description")}`}
              margin='normal'
            />
          </Box>
          <Box sx={{ display: 'flex' ,gap:2}}>
            <Box sx={{width:'50%'}}>
              <Typography>{t("notification_page.Start Date")}</Typography>
              <DateHourPicker
                date={controller.startDate}
                selectedHour={controller.selectedStartDateHour}
                onChangeHour={controller.handleSelectedStartDateHour}
              />
            </Box>
          </Box>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end' }}>
            <Button onClick={() => onClose()} variant='outlined' color='error' sx={{ mr: 2, borderRadius: '10px' }}>
              {t("Close")}
            </Button>
            <Button type='submit' variant="contained" sx={{ textTransform: 'none', borderRadius: '10px', background: '#11A2F1' }}>
              {t("notification_page.Create Notification")}
            </Button>
          </Box>
        </Box>
        <ConfirmDialog
          open={controller.openConfirm}
          title={t('notification_page.Do you want to create this notification')}
          loading={controller.loadingButton}
          onCancel={controller.handleCloseConfirmForm}
          onConfirm={() => controller.handleSubmit()}
        />
      </form>
    </Box>
  );
};
export default NotificationForm;
